import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=b77af9b2&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=ts"
export * from "./Headline.vue?vue&type=script&lang=ts"
import style0 from "./Headline.vue?vue&type=style&index=0&id=b77af9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77af9b2",
  null
  
)

export default component.exports